import MemberPortal from 'dev/member-portal'

export default function(app) {
  // Member Portal
  if (app.registry.getFeature('member-portal')) {
    app.addPlugin(MemberPortal, { lazyStore: true })

    const loadMemberPortalStore = function(store) {
      if (!store.hasModule('memberPortal')) {
        return MemberPortal.store().then(moduleStore => {
          store.registerModule('memberPortal', moduleStore.default, { preserveState: store.state.memberPortal !== undefined })
        })
      }
      return Promise.resolve(true)
    }

    app.addRoutes([
      {
        path: '/user/:user?/:page?',
        component: 'ssr-blocked',
        name: 'Member Portal',
        meta: {
          requiresAuth: 'cache',
          onload: ({store}) => loadMemberPortalStore(store),
          noSSR: {
            active: Boolean(process.env.SERVER_BUILD === 'ssr'),
            component: MemberPortal.MemberPortalMain,
            spinner: 'default-loading-spinner',
            title: 'Loading Member Portal.',
            description: 'Please wait while the member portal is loading...'
          }
        }
      },
      {
        path: '/invoice/:txnid',
        component: MemberPortal.MemberPortalInvoices,
        name: 'Invoice',
        meta: {
          requiresAuth: 'cache',
          onload: ({store}) => loadMemberPortalStore(store)

        }
      },
      {
        path: '/settings/member-portal/somnambulist',
        component: MemberPortal.MemberPortalSomnambulistSettings,
        name: 'Member Portal WineClub Settings',
        meta: {
          requiresAuth: 'cache',
          CheckAccountPermissions: ['administer store'],
          id: 'member-portal-somnambulist',
          title: 'Member Portal WineClub Settings',
          ssr: (process.env.SERVER_BUILD === 'ssr')
        }
      }
    ])
  }
}
